import {useState} from 'react';
import {IconChevronDown} from '../../../assets/images';
import '../MapRightSidebar.scss';
import {ChevronLeft} from '@material-ui/icons';
export default function RightDropdown({
  selectedMenu,
  onClick,
  menu_list,
  bgColor,
  color,
  title = 'Select',
}) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={`mrs_menu_ctr ${open ? 'open' : ''}`}
      style={{
        backgroundColor: bgColor || 'rgba(255, 255, 255, 0.6)',
        color: color || '#000',
      }}
    >
      <div className='mrs_selected' onClick={() => setOpen((prev) => !prev)}>
        <p>{selectedMenu.label || title}</p>
        <ChevronLeft className='mrs_chevron' />
      </div>
      {open && (
        <div className='mrs_list'>
          {menu_list.map((item, index) => (
            <div
              key={index}
              className='mrs_list_item'
              style={{
                color: '#000',
              }}
              onClick={() => {
                onClick(item);
                setOpen(false);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
